import kr from "../assets/kr.svg";
import sk from "../assets/sk.svg";
import us from "../assets/us.svg";
import { useI18n } from "./i18n";

export const LanguagePicker: React.FC<{ className: string }> = ({
  className,
}) => {
  const i18n = useI18n();

  return (
    <span className={`gap-2 flex ${className}`}>
      <button
        onClick={() => i18n.setLanguage("ko")}
        type="button"
        className="cursor-pointer rounded-full bg-stone-500 p-0.5 text-white shadow-xs hover:bg-stone-400 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-stone-500"
      >
        <img src={kr} aria-hidden="true" className="size-8" />
      </button>
      <button
        onClick={() => i18n.setLanguage("sk")}
        type="button"
        className="cursor-pointer rounded-full bg-stone-500 p-0.5 text-white shadow-xs hover:bg-stone-400 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-stone-500"
      >
        <img src={sk} aria-hidden="true" className="size-8" />
      </button>
      <button
        onClick={() => i18n.setLanguage("en")}
        type="button"
        className="cursor-pointer rounded-full bg-stone-500 p-0.5 text-white shadow-xs hover:bg-stone-400 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-stone-500"
      >
        <img src={us} aria-hidden="true" className="size-8" />
      </button>
    </span>
  );
};
